import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { allDevLocationAtom, DevLocation, deviceLocationAtom } from '../atoms-types/devices';
import GolfMap from '../charts-graphs/golfMap';
import useWebSocket from '../../hooks/wsHook';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { endpointLink, websocketLink } from '../../index';

export default function GolfMapHandler() {
  const [, setDevLocations] = useAtom(allDevLocationAtom);
  const [ ,setDeviceLocation] = useAtom(deviceLocationAtom);
  const { messages } = useWebSocket<DevLocation>(websocketLink, ['location']);
  const { deviceEUI } = useParams<{ deviceEUI?: string }>();

  const { isFetching, isError, error } = useQuery({
    queryKey: ['fallbackLocation'],
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<DevLocation[]>(`${endpointLink}fallback-location`);
      const data = response.data;
      UpdateDevLocations(data);
      console.log("all fallback locations: ", data);
      return data;
    }
  });

  function UpdateDevLocations(data: DevLocation[]) {
    const updatedDevLocations = data?.map(loc => ({
      ...loc
    }));
    setDevLocations(updatedDevLocations);
    
    // If viewing a specific device, populate deviceLocationAtom
    if (deviceEUI) {
      console.log('Looking for device:', deviceEUI, 'in data:', data);
      const deviceLocation = data.find(loc => loc.deviceEUI === deviceEUI);
      console.log('Found device location:', deviceLocation);
      if (deviceLocation) {
        setDeviceLocation([deviceLocation]);
        console.log('Set deviceLocationAtom to:', [deviceLocation]);
      }
    }
  }

  useEffect(() => {
    messages.forEach((messageObj) => {
      const { channel, message } = messageObj;
      if (channel === 'location') {
        try {
          // const convertedData = ConvertPayload(data);
          const convertedData = message;
          console.log("message received", convertedData);

          if (convertedData && convertedData.lat != null && convertedData.lng != null) {
            const newDevLocation = {
              deviceEUI: convertedData.deviceEUI,
              name: convertedData.name,
              type: convertedData.type,
              lat: convertedData.lat,
              lng: convertedData.lng,
              area: null,
              timestamp:''
            };

            setDevLocations((prevDevLocations) => {
              console.log("prev:", prevDevLocations);
              console.log("new:", newDevLocation);
              const updatedLocations = prevDevLocations.filter(
                (loc) => loc.deviceEUI !== newDevLocation.deviceEUI
              );
              return [...updatedLocations, newDevLocation];
            });
            if (deviceEUI && deviceEUI === newDevLocation.deviceEUI) {
              setDeviceLocation([newDevLocation]);
              console.log('Updated device locations:', newDevLocation);
            }
          } else {
            console.warn('Received data with invalid or incomplete location info:', convertedData);
          }
        } catch (err) {
          console.error('Error parsing message:', err);
        }
      }
    });
  }, [messages, setDevLocations, deviceEUI, setDeviceLocation]);

    const renderLoadingOrError = () => {
    if (isFetching) {
      return <p>Loading...</p>;
    } else if (isError) {
      return <p>Error: {error.message}</p>;
    }
    return null;
  };

  return (
    <div>
      {renderLoadingOrError()}
      <GolfMap />
    </div>
  );
}


